import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "@/config";

import { zhCN, zhTW, en, th, pt, hi, es } from "@/i18n";

let resources = {
  "zh-CN": { translation: zhCN },
  "zh-TW": { translation: zhTW },
  en: { translation: en },
  th: { translation: th },
  pt: { translation: pt },
  hi: { translation: hi },
  es: { translation: es },
};

i18n
  .use(LanguageDetector) // 嗅探当前浏览器语言
  .use(initReactI18next) // init i18next
  .init({
    // 引入资源文件
    resources,
    // 选择默认语言，选择内容为上述配置中的key，即en/zh
    fallbackLng: DEFAULT_LANGUAGE,
    lng: localStorage.getItem("i18nextLng") || DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
